export default __webpack_public_path__ + "static/media/doneEffect.aeeafc90.mp3";